import React from "react";
import ReactDOM from "react-dom/client";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "admin-lte/dist/css/adminlte.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css";

// admin_lte

import "./index.css";
import App from "./App";
import { FrontPage } from "./views/FrontPage";
import { Home } from "./views/Home";
import { Deposit } from "./views/Deposit";
import { Withdraw } from "./views/Report/Withdraw";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/Authcontext";
import { Withdrawreport } from "./views/Report/Withdrawreport";
import { Depositereport } from "./views/Report/Depositereport";
import { Changepassword } from "./views/Report/Changepassword";
import { Stakebutton } from "./views/Report/Stakebutton";
import { Result } from "./views/Report/Result";
import { Activitylogs } from "./views/Report/Activitylogs";
import { Plstatement } from "./views/Report/Plstatement";
import { Accountstatement } from "./views/Report/Accountstatement";
import SportsBook from "./views/Report/SportsBook";
// import { Home } from './views/home';
import Dashboard from "./views/admin/Dashboard";

// Make jQuery globally available
import $ from "jquery";
import AdminUsers from "./views/admin/components/AdminUsers";
import AdminUserSetting from "./views/admin/components/userSetting";
import AdminSettings from "./views/admin/components/AdminSettings";
import AdminRoles from "./views/admin/components/AdminRoles";
import AdminMatches from "./views/admin/components/AdminMatches";
import ManageMarket from "./views/admin/components/ManageMarket";
import MyMarket from "./views/admin/components/MyMarket";
import MatchesHistory from "./views/admin/components/MatchesHistory";
import FancyHistory from "./views/admin/components/FancyHistory";
import ManageFancy from "./views/admin/components/ManageFancy";
import Bonus from "./views/admin/components/Bonus";
// import Bank from "./views/admin/components/Bank";
import AdminAddRoles from "./views/admin/components/AdminAddRoles";
import ProtectedRoute from "./views/admin/ProtectedRoute";
import AdminLogin from "./views/admin/AdminLogin";
import BrowseRecharge from "./views/admin/components/BrowseRecharge";
import BrowseWithdrawl from "./views/admin/components/BrowseWithdrawl";
import SportsBets from "./views/Report/SportsBets";
import ProfitLoss from "./views/admin/components/ProfitLoss";
import DepositHistory from "./views/admin/components/DepositHistory";
import WithdrawHistory from "./views/admin/components/WithdrawHistory";
import { Toaster } from "react-hot-toast";
import Admin from "./views/admin/components/Admin";
import Jili from "./views/Jili";
import ProtectedRouteUser from "./views/components/ProtectedRouteUser";
import AviatorGames from "./views/AviatorGames";
import ContactUs from "./views/ContactUs";
import CookiePolicy from "./views/CookiePolicy";
import TurboGames from "./views/GamingProviders/TurboGames";
import EvolutionGames from "./views/GamingProviders/EvolutionGames";
import EzugiGames from "./views/GamingProviders/EzugiGames";
import RedTiger from "./views/GamingProviders/RedTiger";
import MaccGames from "./views/GamingProviders/MaccGames";
import JdbGaming from "./views/GamingProviders/JdbGaming";
import BetHistory from "./views/admin/components/BetHistory";
import Lobby from "./views/GamingProviders/Lobby";
import LiveCasino from "./views/GamingProviders/LiveCasino";
import Master from "./views/admin/components/Master";
import AddSlider from "./views/admin/components/AddSlider";
import Slider from "./views/admin/components/Slider";
import SuperMaster from "./views/admin/components/SuperMaster";
import JiliAll from "./views/JiliAll";
import JDBAll from "./views/JDBAll";
import SportHistory from "./views/admin/components/SportHistory";
import Cricket from "./views/Cricket";
import SuperAdmin from "./views/admin/components/SuperAdmin";
import Agent from "./views/admin/components/Agent";
import EditSlider from "./views/admin/components/EditSlider";
import PgSoftAll from "./views/PgSoftAll";
import CQ9All from "./views/CQ9All";
import RummyHome from "./views/GamingProviders/RummyHome";
import SpribeHome from "./views/GamingProviders/SpribeHome";
import CQ9Home from "./views/GamingProviders/CQ9Home";
import PgSoftHome from "./views/GamingProviders/PgSoftHome";
import TurboAll from "./views/TurboAll";
import SuperAdminChip from "./views/admin/components/SuperAdminChip";
import UserChip from "./views/admin/components/UserChip";
import Profile from "./views/admin/components/Profile";
import Menu from "./views/Menu";
import CommissionHistory from "./views/admin/components/CommissionHistory";
import AdminBonus from "./views/admin/components/AdminBonus";
import CricketAll from "./views/CricketAll";
import UserStatment from "./views/admin/components/UserStatement";
import WeekReport from "./views/admin/components/WeekReport";
import CategoryGrid from "./views/components/CategoryGrid";
import Register from "./views/RegisterForm";

import CricketReal from "./views/CricketReal";
import FootballReal from "./views/FootballReal";
import TennisReal from "./views/TennisReal";
import FootBAll from "./views/FootBall";
import Tennis from "./views/Tennis";
import Inplays from "./views/Inplays";
import CasinoGames from "./views/CasinoGames";
import CasinoHistory from "./views/admin/components/CasinoHistory";
import UserBetHistory from "./views/admin/components/UserBetHistory";
import UserSportsSetting from "./views/admin/components/UserSportsSetting";
import PromoCode from "./views/admin/components/PromoCode";
import AdminBankList from "./views/admin/components/AdminBankList";
import MarketAnalysis from "./views/admin/components/MarketAnalysis";

import WeeklyReportsUser from "./views/admin/components/WeeklyReportsUser";
import MarketAnalysisBets from "./views/admin/components/MarketAnalysisBets";
import MarketAnalysisFootBallBets from "./views/admin/components/MarketAnalysisFootBallBets";
import MarketAnalysisTennisBets from "./views/admin/components/MarketAnalysisTennisBets";
import { ThemeProvider } from "./context/ThemeContext";
import EditLogo from "./views/admin/components/EditLogo";
import EditModal from "./views/admin/components/EditModal";
import LoginReg from "./views/LoginReg";
import Settlement from "./views/admin/components/Settlement";
import SettleHistory from "./views/admin/components/SettleHistory";
import FancyBetsResult from "./views/admin/components/FancyBetsResult";
import DeletedBets from "./views/admin/components/DeletedBets";
import HomeCricket from "./views/admin/components/HomeCricket";
import HomeFootball from "./views/admin/components/HomeFootball";
import HomeTennis from "./views/admin/components/HomeTennis";
import AdminHome from "./views/admin/components/AdminHome";
import DelayPage from "./views/admin/components/DelayPage";
import MatchHistoryManage from "./views/admin/components/MatchHistoryManage";
import GetAllMatchBet from "./views/admin/components/GetAllMatchBet";
import ChildUsers from "./views/admin/components/ChildUsers";
import { TermsCondition } from "./views/TermsCondition";
import { ResponsibleGaming } from "./views/ResponsibleGaming";
import MarketOverview from "./views/admin/components/MarketOverview";
import AdminUsers2 from "./views/admin/components/Adminuser2";
import AddClient from "./views/admin/components/AddClient";
import AdminLayout from "./views/admin/AdminLayout";



window.jQuery = $;
window.$ = $;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    <AuthProvider>
      <ThemeProvider>
        <Toaster position="top-right" reverseOrder={false} />
        <Routes>
          <Route path="/" element={<LoginReg />} />
          <Route path="/home" element={<Home />} />
          <Route path="/termsCondition" element={<TermsCondition />} />
          <Route path="/responsibleGaming" element={<ResponsibleGaming />} />
          <Route path="/login" element={<LoginReg />} />


          <Route element={<ProtectedRouteUser />}>

            <Route path="/changepassword" element={<Changepassword />} />
            <Route path="/stakebutton" element={<Stakebutton />} />
            <Route path="/deposit" element={<Deposit />} />
            <Route path="/withdraw" element={<Withdraw />} />
            <Route path="/withdrawhistory" element={<Withdrawreport />} />
            <Route path="/depositehistory" element={<Depositereport />} />
            <Route path="/result" element={<Result />} />
            <Route path="/activitylogs" element={<Activitylogs />} />
            <Route path="/plstatement" element={<Plstatement />} />
            <Route path="/accountstatement" element={<Accountstatement />} />

            <Route path="/jiliAll" element={<JiliAll />} />
            <Route path="/jdbAll" element={<JDBAll />} />
            <Route path="/pgsoftAll" element={<PgSoftAll />} />
            <Route path="/cq9All" element={<CQ9All />} />
            <Route path="/rummyHome" element={<RummyHome />} />
            <Route path="/spribeHome" element={<SpribeHome />} />
            <Route path="/cQ9Home" element={<CQ9Home />} />
            <Route path="/pgSoftHome" element={<PgSoftHome />} />
            <Route path="/turboAll" element={<TurboAll />} />

            {/* <Route path='/games' element={<Games/>}/>
          <Route path='/sports/:id' element={<Sports/>}/> */}
            <Route path="/live-casino" element={<LiveCasino />} />
            <Route path="/jili" element={<Jili />} />
            <Route path="/turbo-games" element={<TurboGames />} />
            <Route path="/evolution-games" element={<EvolutionGames />} />
            <Route path="/ezugi-games" element={<EzugiGames />} />
            <Route path="/redtiger-games" element={<RedTiger />} />
            <Route path="/macc-games" element={<MaccGames />} />
            <Route path="/jdb-games" element={<JdbGaming />} />
            <Route path="/aviator-games" element={<AviatorGames />} />
            <Route path="/sportsbook" element={<SportsBook />} />
            <Route path="/sports_bets" element={<SportsBets />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/app" element={<App />} />
            <Route path="/lobby" element={<Lobby />} />
            <Route path="/cricketBet" element={<Cricket />} />
            <Route path="/footBAllBet" element={<FootBAll />} />
            <Route path="/tennis" element={<Tennis />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/sportall" element={<CricketAll />} />
            <Route path="/CategoryGrid" element={<CategoryGrid />} />
            <Route path="/registerPage" element={<Register />} />
            <Route path="/cricketreal" element={<CricketReal />} />
            <Route path="/footballreal" element={<FootballReal />} />
            <Route path="/tennisreal" element={<TennisReal />} />
            <Route path="/inplay" element={<Inplays />} />
            <Route path="/casinoGames" element={<CasinoGames />} />

          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/" element={<AdminLayout />}>
            <Route element={<ProtectedRoute />}>
              <Route path="/admin/dashboard" element={<Dashboard />} />
              <Route path="/admin/Admin" element={<Admin />} />
              <Route path="/admin/user" element={<AdminUsers />} />
              <Route path="/admin/user2" element={<AdminUsers2 />} />
              <Route path="/admin/addClient" element={<AddClient />} />
              <Route
                path="/admin/userSetting/:user_phone/:user_code"
                element={<AdminUserSetting />}
              />
              <Route
                path="/admin/userSetting/:user_phone"
                element={<AdminUserSetting />}
              />
              <Route
                path="/admin/userBetHistory/:user_phone"
                element={<UserBetHistory />}
              />
              <Route
                path="/admin/userWeeklyReport/:user_phone"
                element={<WeeklyReportsUser />}
              />
              <Route path="/admin/getChildUsers/:code" element={<ChildUsers />} />
              <Route path="/admin/browse_recharge" element={<BrowseRecharge />} />
              <Route
                path="/admin/browse_withdrawl"
                element={<BrowseWithdrawl />}
              />
              <Route path="/admin/settings" element={<AdminSettings />} />
              <Route path="/admin/roles" element={<AdminRoles />} />
              <Route path="/admin/matches" element={<AdminMatches />} />
              <Route path="/admin/deposit_history" element={<DepositHistory />} />
              <Route
                path="/admin/withdraw_history"
                element={<WithdrawHistory />}
              />
              <Route path="/admin/manage_market" element={<ManageMarket />} />
              <Route path="/admin/my_market" element={<MyMarket />} />
              <Route path="/admin/matches_history" element={<MatchesHistory />} />
              <Route
                path="/admin/userSportsSetting/:phone"
                element={<UserSportsSetting />}
              />

              <Route path="/admin/fancy_history" element={<FancyHistory />} />
              <Route path="/admin/manage_fancy" element={<ManageFancy />} />
              <Route path="/admin/bonus" element={<Bonus />} />
              {/* <Route path="/admin/bank" element={<Bank />} /> */}
              <Route path="/admin/add_roles" element={<AdminAddRoles />} />
              <Route path="/admin/profitloss" element={<ProfitLoss />} />
              <Route path="/admin/betHistory" element={<BetHistory />} />
              <Route path="/admin/master" element={<Master />} />
              <Route path="/admin/supermaster" element={<SuperMaster />} />
              <Route path="/admin/slider" element={<Slider />} />
              <Route path="/admin/addSlider" element={<AddSlider />} />
              <Route path="/admin/sportHistory" element={<SportHistory />} />
              <Route path="/admin/weekReport" element={<WeekReport />} />
              <Route path="/admin/superAdmin" element={<SuperAdmin />} />
              <Route path="/admin/Agent" element={<Agent />} />
              <Route path="/admin/editSlider/:id" element={<EditSlider />} />
              <Route path="/admin/editLogo/:id" element={<EditLogo />} />
              <Route path="/admin/editModal/:id" element={<EditModal />} />
              <Route path="/admin/adminChip" element={<SuperAdminChip />} />
              <Route path="/admin/userChip" element={<UserChip />} />
              <Route path="/admin/Profile" element={<Profile />} />
              <Route
                path="/admin/commissionHistory"
                element={<CommissionHistory />}
              />
              <Route path="/admin/adminbonus" element={<AdminBonus />} />
              <Route path="/admin/userStatement" element={<UserStatment />} />
              <Route path="/admin/casinohistory" element={<CasinoHistory />} />
              {/* <Route path="/admin/promocode" element={<PromoCode />}/> */}
              <Route path="/admin/userStatement/:id" element={<UserStatment />} />

              <Route path="/admin/bankList" element={<AdminBankList />} />
              <Route path="/admin/marketAnalysis" element={<MarketAnalysis />} />
              <Route path="/admin/MarketOverview" element={<MarketOverview />} />
              <Route
                path="/admin/cricket/marketBetAnalysis/:marketId2"
                element={<MarketAnalysisBets />}
              />
              <Route
                path="/admin/tennis/marketBetAnalysis/:marketId2"
                element={<MarketAnalysisTennisBets />}
              />
              <Route
                path="/admin/football/marketBetAnalysis/:marketId2"
                element={<MarketAnalysisFootBallBets />}
              />
              <Route path="/admin/settlement" element={<Settlement />} />
              <Route path="/admin/settleHistory" element={<SettleHistory />} />
              <Route
                path="/admin/getfancybets/:eventid"
                element={<FancyBetsResult />}
              />
              <Route path="/admin/getDeleteBets" element={<DeletedBets />} />
              <Route path="/admin/fancyHistory" element={<FancyHistory />} />
              <Route path="/admin/home" element={<AdminHome />} />
              <Route path="/admin/homecricket" element={<HomeCricket />} />
              <Route path="/admin/homefootball" element={<HomeFootball />} />
              <Route path="/admin/hometennis" element={<HomeTennis />} />
              <Route path="/admin/eventDelay" element={<DelayPage />} />
              <Route
                path="/admin/matchHistoryManage"
                element={<MatchHistoryManage />}
              />
              <Route
                path="/admin/getAllMatchBet/:eventId"
                element={<GetAllMatchBet />}
              />
            </Route>
          </Route>
        </Routes>
      </ThemeProvider>
    </AuthProvider>
  </Router>,
);

reportWebVitals();
